import { getParticipantData } from "../../../Helpers/GetParticipantData";
import { Participant, AggregatedScoresMap } from "../../../Constants";
export class AggregatedScoresDataParser {
    static parse(event) {
        let participant1 = getParticipantData(event, Participant.One);
        let participant2 = getParticipantData(event, Participant.Two);
        return {
            participant1data: this.getAggregatedScoresData(event, participant1, "1"),
            participant2data: this.getAggregatedScoresData(event, participant2, "2")
        };
    }
    static getAggregatedScoresData(event, participantData, participant) {
        let result = {};
        let scores = event.score || { additionalScores: {
                cornersTeam1: "-",
                cornersTeam2: "-",
                penaltiesTeam1: "-",
                penaltiesTeam2: "-",
                redCardsTeam1: "-",
                redCardsTeam2: "-",
                yellowCardsTeam1: "-",
                yellowCardsTeam2: "-"
            }
        };
        result.participantScoreId = `${event.id}-participant-${participant}`;
        result.name = participantData.name;
        Object.keys(scores.additionalScores)
            .filter(function (key) { return key.indexOf(participant) !== -1; })
            .forEach(function (key) {
            AggregatedScoresMap[key] && (result[AggregatedScoresMap[key]] = scores.additionalScores[key]);
        });
        result.goals = participantData.score;
        return result;
    }
}
//# sourceMappingURL=AggregatedScoresDataParser.js.map